import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Paper, Button, Table, TableBody, Checkbox, TableCell, TableHead, TableRow, TableSortLabel, Grid } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DeletePopUp from "../../../../shared_elements/components/DeletePopUp";
import { SubleaseList } from "../components";
import { LeasesMenuList, LeasesNav } from "../../../elements";
import { Pagination, STableLoader, PageLoader } from "../../../../shared_elements";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { getSubleaseApi, deleteSubleaseApi } from "../apiServices";
import { checkApiStatus } from "../../../../utils";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { enqueueSnackbar } from "notistack";
import { ButtonLoader, ShowAttachments } from "../../../../shared_elements/components";
import SubleaseCRU from "../components/SubleaseCRU";
import { PermissionWrapper } from "../../../../wrappers";
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from "../../../elements/LeasesBasicDetails";
import { trackActivity } from "../../../../utils/mixpanel";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import { useDispatch, useSelector } from "react-redux";
import { getStorage } from "../../../../shared_elements/actionCreators";
import FileUploadLayout from "../../../../shared_elements/components/FileUploadLayout";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import fileUpload, { getApiResponse } from "../../../../utils/fileUpload";
import SubleaseCardView from "../components/SubleaseCardView";
import CustomTabs from "../../../../shared_elements/components/CustomTabs";
import BackToLeaseList from "../../../elements/BackToLeaseList";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 290px)';

const SubleaseHd = ({ toggleBulkOps, bulk, createSortHandler, sortInfo, item }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Sublease`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                disabled={key === "lessee" || key === "lessor" ? true : false}
                hideSortIcon={key === "lessee" || key === "lessor" ? true : false}
                active={sortInfo?.sort_by === key ? true : false}
                direction={sortInfo?.sort_by === key ? sortInfo?.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: 'lease_revamp', feature: 'sublease', operationType: ['D'] }}>
                        <Checkbox disableRipple color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item, item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>{tableSorting("sublease_lessee", "Name")}</TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: 'nowrap'}}>{tableSorting("start_date", "Start Date")} </TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: 'nowrap' }}>{tableSorting("end_date", "End Date")}</TableCell>
                <TableCell>{tableSorting("details", "Details")}</TableCell>
            </TableRow>
        </TableHead>
    );
};

const Sublease = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch()
    const { fileUploadDetails } = useSelector((state) => state.leases);
    const { leaseSlug } = useParams();
    const params = { leaseSlug };
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [subleaseInfo, setSubleaseInfo] = useState({ list: [], pagination: {} });
    const [addEditSublease, setAddEditSublease] = useState({ mode: '', modal: false, data: null });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
    const [deletSublease, setDeleteSublease] = useState({ modal: false, data: null, })
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [attachments, setAttachments] = useState({ modal: false, data: null, mode: '' })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [isExport, seIsExport] = useState(false)
    const [uploadFileProgressData, setUploadFileProgressData] = useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})
    const [tabIndex, setTabIndex] = useState(0);



    useEffect(() => {
        const uploadedFileData = getApiResponse("sublease", slug);
        getSubleaseList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Sublease' })
        setUploadFileProgressData({ uploadedFileData });
    }, []);

    const getSubleaseList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getSubleaseApi(params, query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setSubleaseInfo(response.data.data);
            } else {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            }
        })
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "sublease" }))
    };

    const deleteSubleaseFn = () => {
        const idsToDelete = deletSublease?.modal && deletSublease?.data?.id ? [deletSublease?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        setLoading(true);
        globalDeleteService(deleteSubleaseApi(params), { ids: idsToDelete } )
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Sublease`, success_msg: response?.data?.message, item_ids: deletSublease?.data || bulk?.ids, response: response?.data })
                    setDeleteSublease({ modal: false, data: null });
                    getSubleaseList('fetch', { per_page: subleaseInfo?.pagination?.per_page });
                    setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Sublease`, error_msg: response?.data?.message, item_ids: deletSublease?.data || bulk?.ids, response: response?.data })
                }
            })
    };

    const onDeteAttchments = (deltedslug) => {
        setLoading(true);
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (addEditSublease?.modal) {
            setAddEditSublease({
                ...addEditSublease,
                data: {
                    ...addEditSublease.data,
                    attachments: addEditSublease.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        // getSubleaseApi('', { per_page: subleaseInfo?.pagination?.per_page });
        getSubleaseList("fetch", { per_page: subleaseInfo?.pagination?.per_page });
    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getSubleaseList('', { ...sortQuery, per_page: subleaseInfo?.pagination?.per_page });
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getSubleaseApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }

    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "sublease",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                getSubleaseList("fetch", { per_page: subleaseInfo?.pagination?.per_page  || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
        });
        setSlug({})
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Sublease`, page_type: page_type, })
    }

    const openAddItemModal = () => {
        setAddEditSublease({
            modal: true,
            data: {
                sublease_lessee: "",
                details: "",
                start_date: null,
                end_date: null,
                remarks: "",
                attachments: []
            },
            mode: 'add',
        });
        handleItemClicked('Add Item Button')
    };

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
                <LeasesNav type="basic"/>
                <div className="lease-details-content contnet-overflow">
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Sublease" type="basic" />
                            </Grid>
                           <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'0px', float:'right',minHeight:'35px'}}>
                                    <li className='lease-mobile-button revision-history'>
                                        <ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} />
                                    </li> 
                                {tabIndex === 0 && <>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "sublease", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }</>}
                                    {subleaseInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button> </li> : null}
                                    {tabIndex === 0 ?
                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "sublease", operationType: ['C'] }}>
                                            <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" color="primary" onClick={openAddItemModal}> Add Sublease </Button> </li>
                                        </PermissionWrapper> 
                                    : null}
                                     </ul>
                            </Grid>
                            <Grid item size={{ md: 12 }} mt='5px' sx={{ display: { xs: "none", sm: "block" } }}>
                                <CustomTabs
                                    tabsList={['Sublease', 'Sublease Config']}
                                    onChange={(e, val) => setTabIndex(val)}
                                    value={tabIndex}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    {isMobile ? <SubleaseCardView /> : tabIndex === 1 ? <SubleaseCardView /> : null}
                    {(isMobile || tabIndex === 0) ?
                        <Paper className='lease-detail-table table-tab-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: subleaseInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                            <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                                {skeletonLoader ? <STableLoader count={4} rowCount={12} /> : (
                                    <Table className="mui-table-format" stickyHeader>
                                        <SubleaseHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={subleaseInfo?.list} toggleBulkOps={toggleBulkOps} />
                                        <TableBody>
                                            {subleaseInfo?.list?.length > 0 && subleaseInfo?.list?.map((item, index) => {
                                                const uploadedFileData = getApiResponse("sublease", item?.slug);

                                                return (
                                                    <SubleaseList
                                                        slug={slug?.slug}
                                                        uploadedFileData={uploadedFileData}
                                                        uploadFileProgressData={uploadFileProgressData}
                                                        viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                        key={index}
                                                        item={item}
                                                        bulk={bulk}
                                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                        onEditFn={() => setAddEditSublease({ modal: true, data: item, mode: 'edit' })}
                                                        onView={() => setAddEditSublease({ modal: true, data: item, mode: 'view' })}
                                                        onDeleteEolFn={() => {
                                                            setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                            setDeleteSublease({ modal: true, data: item, })
                                                        }}
                                                        toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                                        onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                                                    />
                                                )
                                            }
                                            )}
                                        </TableBody>
                                    </Table>
                                )}
                                {!skeletonLoader && !subleaseInfo?.list?.length && <NoRecordFound />}
                            </div>
                            <Paper square>
                                <Pagination
                                    pagination={subleaseInfo?.pagination} onPageChange={(event, newPage) => { const pageNum = newPage + 1; getSubleaseList("Pageloader", { page: pageNum, per_page: subleaseInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }} onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getSubleaseList("Pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                                />
                            </Paper>
                        </Paper> : null}
                </div>
            </Paper>
            {
                addEditSublease.modal && (
                    <SubleaseCRU
                        fileUpload={handleUpload}
                        addEditSublease={addEditSublease}
                        modeType={addEditSublease?.mode}
                        getResponseBack={() => {getSubleaseList('fetch', { per_page: subleaseInfo.pagination.per_page }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                        onOpenAttachments={() => setAttachments({ modal: true, data: addEditSublease?.data, mode: 'view' })}
                        onToggleModal={() => setAddEditSublease({ modal: false, data: null, mode: '' })}
                    />
                )
            }

            {deletSublease.modal &&
                <DeletePopUp
                    modal={deletSublease.modal}
                    title='Delete Sub Lease Option'
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        setDeleteSublease({ modal: false, data: null });
                        setBulk({ modal: false, ids: [], title: '', type: '' });
                    }}
                    onDeleteRecords={() => deleteSubleaseFn()}
                />}
            {attachments.modal ?
                <ShowAttachments
                    moduleName="Sub Lease"
                    url='delete-attachment'
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null, mode: '' })}
                    onViewDisabled={addEditSublease?.mode === 'view' || attachments?.mode === 'view'}
                    permissionKey='sublease'
                /> : null
            }
            {bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal}
                    title={`Delete ${bulk?.ids?.length && bulk.ids.length === (subleaseInfo?.list?.length || 0) ? 'All Sub Lease' : 'Selected Sub Lease'}`}
                    onDeleteRecords={() => deleteSubleaseFn()}
                    content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
                    onToggleModal={() => setBulk({ modal: false, ids: [] })}
                /> : null
            }
            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"sublease"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    );

};

export default RoleBaseAccess(Sublease, { application: 'lease_revamp', feature: 'sublease', operationType: ['R'] });
